/**
 * Forces a timeout to the specified promise if the promise resolves before the given timeout
 *
 * @param promise
 * @param timeout the minimum number of milliseconds to wait
 */
export const forceTimeoutIfNeeded = async <T>(promise: Promise<T>, timeout: number): Promise<T> => {
  const wait = new Promise((resolve) => {
    setTimeout(() => {
      resolve(true);
    }, timeout);
  });

  const [promiseWithTimeout] = await Promise.all([promise, wait]);
  return promiseWithTimeout;
};
